// 消息类型
export enum ENoticeType {
  // 全部
  All = "all",
  // 未读
  Unread = "noread",
  // 收藏
  Collect = "collection"
}

// 消息面向的对象： 个人 | 群组
export enum EPtype {
  // 单个
  Single = 0,
  // 多个
  Group = 1
}

// 消息读取状态
export enum EReadStatus {
  // 已读
  Yes = 1,
  // 未读
  No = 0
}

// 消息收藏状态
export enum ECollectStatus {
  // 已收藏
  Yes = 1,
  // 未收藏
  No = 0
}

// 消息级别
export enum ENoticeLevel {
  // 普通
  General = 1,
  // 重要的
  Importance = 0
}

// 客服消息关系
export enum ENESNoticeContact {
  // 发送者
  Master = 1,
  // 接受者
  Receiver = 0
}

// WebSite消息模板
export enum EWebSiteTemplate {
  // 系统登录时发送的消息
  Login = 1,
  // 异常订单提醒
  Abnormal,
  // 订单状态更新时
  OrderUpdate,
  // 客服发送的群组消息
  GroupNotice,
  // 客服发送的客服消息
  NCSNotice,
  // 临时添加的消息，一般指的是自己发送的消息
  TemporaryNotice = 99
}

// Browser 浏览器消息模板
export enum EBrowserTemplate {
  // 系统登录时发送的消息
  Login = 1,
  // 订单状态更新时
  OrderUpdate,
  // 客服发送的消息
  NCSNotice
}
